import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { useCarouselContext, useCarouselSlidesContext, useCarouselViewportContext } from "../context";
const _CarouselSlide = ({ children, index, ...htmlProps }) => {
    const { state: { activeSlideIndex, nSlides }, dispatch, } = useCarouselContext("CarouselSlide");
    useCarouselSlidesContext("CarouselSlide");
    const { hasFocus } = useCarouselViewportContext("CarouselSlide");
    const ref = useRef(null);
    const isActive = activeSlideIndex === index;
    useEffect(() => {
        const handleKeyUp = (e) => {
            const currentDataFocused = ref.current?.getAttribute("data-focused");
            const parentDataFocused = ref.current?.parentElement?.getAttribute("data-focused");
            const inFocus = document.activeElement &&
                ref.current &&
                document.activeElement.contains(ref.current) &&
                (!currentDataFocused || currentDataFocused === "true") &&
                (!parentDataFocused || parentDataFocused === "true");
            if (!(inFocus && isActive)) {
                return;
            }
            if (e.key === "Enter") {
                inFocus && dispatch({ type: "goTo", index: index });
                ref.current?.click();
            }
        };
        document.addEventListener("keyup", handleKeyUp);
        return () => {
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, [isActive, dispatch, index]);
    return (React.createElement("li", { ref: ref, role: "group", "aria-roledescription": "slide", "data-focused": isActive && hasFocus, "aria-label": index !== undefined ? `${index + 1} of ${nSlides}` : "", "data-testid": "slide", "data-slide-active": isActive, "aria-hidden": isActive ? "false" : "true", ...htmlProps }, children));
};
export const CarouselSlide = styled(_CarouselSlide) ``;
//# sourceMappingURL=CarouselSlide.js.map